import { useDataValue, useDataChange } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import React, { useMemo } from 'react'
import View from './view.js'
import TysiaText from 'DesignSystem/TysiaText/index.js'
import StatusToggle from './StatusToggle/index.js'
import { format, parseISO } from 'date-fns'

export default function Logic(props) {
  let tokens = useDataValue({
    context: 'tokens',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  let value = useMemo(() => {
    return {
      columns: [
        {
          header: 'Description',
          accessorKey: 'description',
        },
        {
          header: 'Key',
          accessorKey: 'key',
        },
        {
          header: 'Masked Secret',
          accessorKey: 'masked_secret',
        },
        {
          header: 'Expires At',
          accessorKey: 'expires_at',
          cell: cell => (
            <TysiaText
              text={format(parseISO(cell.getValue()), 'd MMM, yyyy')}
              viewPath={props.viewPath}
            />
          ),
        },
        {
          header: 'Active',
          accessorKey: 'status',
          cell: cell => (
            <StatusToggle
              isActive={cell.row.original.status === 'active'}
              viewPath={props.viewPath}
              onChange={event => {
                change(next => {
                  next.selected.developers = {
                    id: cell.row.original.id,
                    status:
                      cell.row.original.status === 'active'
                        ? 'inactive'
                        : 'active',
                  }
                })
                setFlowTo(
                  normalizePath(props.viewPath, './ChangeStatus/Content')
                )
              }}
            />
          ),
        },
      ],
      data: tokens || [],
    }
  }, [tokens])

  return <View value={value} viewPath={props.viewPath} />
}
